import React, { useRef } from "react";
import { SideBar } from "../component/SideBar";
import Gallery from "../component/Gallery";
import { data } from "../data/StillImagesData";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import MobileNavbar from "../component/MobileNavbar";

const StillImagesPage = () => {
  const galleryRef = useRef(null);

  const scrollUp = () => {
    if (galleryRef.current) {
      galleryRef.current.scrollBy({ top: -200, behavior: "smooth" });
    }
  };

  const scrollDown = () => {
    if (galleryRef.current) {
      galleryRef.current.scrollBy({ top: 200, behavior: "smooth" });
    }
  };

  return (
    <>
      <MobileNavbar />
      <div className="min-h-screen bg-white font-sans text-gray-700 flex justify-center lg:pt-24 sm:pt-5 md:pt-10 pt-5 gap-40">
        <SideBar />
        <div className="flex flex-col gap-2">
          <div className="w-full max-w-3xl relative flex gap-2">
            <div ref={galleryRef} className="lg:mx-0 md:mx-0 mx-1 lg:max-h-[456px] max-h-[75vh]" style={{ overflow: "auto" }}>
              <Gallery data={data} />
            </div>
            <div className="hidden flex-col gap-6 lg:flex sm:hidden md:hidden " style={{ maxHeight: "460px" }}>
              <button
                onClick={scrollUp}
                className="bg-white border-2 text-lg text-black shadow-md px-3 py-2 rounded-full hover:bg-black hover:text-white transition-all">
                <ChevronUpIcon className="h-[14px]" />
              </button>
              <button
                onClick={scrollDown}
                className="bg-white border-2 text-lg text-black shadow-md px-3 py-2 rounded-full hover:bg-black hover:text-white transition-all">
                <ChevronDownIcon className="h-[14px]" />
              </button>
            </div>
          </div>
          <h3 className="text-end mt-2 lg:mr-[60px] mr-[30px] text-[12px]">Thumbnails, click to enlarge</h3>
        </div>

      </div>
    </>
  );
};

export default StillImagesPage;
